import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { trendingVideos } from '@/mocks/videos';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % trendingVideos.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = useCallback((index: number) => {
    setCurrent(index);
  }, []);

  const video = trendingVideos[current];

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        {trendingVideos.map((v, i) => (
          <div
            key={v.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === current ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={v.image}
              alt={v.title}
              className="w-full h-full object-cover"
              loading={i === 0 ? 'eager' : 'lazy'}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/30" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/20" />
          </div>
        ))}
      </div>

      <div className="relative z-10 w-full h-full flex items-end pb-12 md:pb-20 pt-32 md:pt-40 px-4 md:px-6 lg:px-8">
        <div className="w-full max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full mb-5">
            <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse" />
            <span className="text-primary-400 text-xs font-medium">今日热门推荐</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4 tracking-tight">
            {video.title}
          </h1>

          <div className="flex items-center gap-4 text-sm text-foreground-400 mb-6 flex-wrap">
            <span className="flex items-center gap-1.5">
              <i className="ri-film-line text-primary-500" />
              {video.categoryName}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line" />
              {video.duration}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line" />
              {video.views}次观看
            </span>
            <span className="flex items-center gap-1 text-amber-400">
              <i className="ri-star-fill" />
              {video.rating}
            </span>
          </div>

          <p className="text-foreground-400 text-base md:text-lg max-w-xl leading-relaxed mb-8">
            {video.description || '精彩内容，即刻观看。91视频网站为您精选每日最热门的优质视频内容。'}
          </p>

          <div className="flex items-center gap-4 flex-wrap">
            <Link
              to={`/category/${video.category}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-xl hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-fill" />
              立即观看
            </Link>
            <Link
              to={`/category/${video.category}`}
              className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-700 text-foreground-300 font-medium rounded-xl hover:border-primary-500 hover:text-primary-500 transition-colors"
            >
              <i className="ri-add-line" />
              加入收藏
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {trendingVideos.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === current ? 'w-8 bg-primary-500' : 'w-1.5 bg-foreground-600 hover:bg-foreground-400'
              }`}
              aria-label={`切换到第${i + 1}张推荐`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}